import React, { useEffect, useState } from 'react';
import { Select } from 'antd';

import { useAccess } from '../../../auth/AccessContext.jsx';
import { fundOptions } from './bankStatement/statementLines.js';

/**
 * The fund dropdown Bank Statement, Pending and Rejected share: the
 * register's funds when the viewer may read them, and every fund already
 * on the page so the filter always offers those.
 *
 * @param {{ fundId: string|null, onChange: (fundId: string|null) => void, seen?: string[], className?: string }} props
 */
const ApprovalFundFilter = ({ fundId, onChange, seen = [], className = 'statement-fund-filter' }) => {
    const { api, canView } = useAccess();
    const readsFunds = canView('registry') || canView('unitPrices');
    const [funds, setFunds] = useState([]);

    useEffect(() => {
        if (!readsFunds) return undefined;
        let live = true;
        api.register.funds()
            .then(({ funds: list }) => { if (live) setFunds(list ?? []); })
            .catch(() => {});
        return () => { live = false; };
    }, [api, readsFunds]);

    return (
        <Select
            className={className}
            allowClear
            placeholder="All Funds"
            value={fundId ?? undefined}
            onChange={(v) => onChange(v ?? null)}
            options={fundOptions(funds, seen)}
            aria-label="Fund"
        />
    );
};

export default ApprovalFundFilter;
